import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import StarBackground from "../components/StarBackground";
import Header from "../components/Header";
import Character from "../components/Character";
import { getTranslation } from '../config/translations'; // Import getTranslation
import { API_BASE_URL } from '../api/config';
import { AppContext } from '../contexts/AppContext';
import PlanetsBackground from "../components/PlanetsBackground";
import '../styles/Home.css';
import '../styles/Login.css';

export default function Login() {
    const [userId, setUserId] = useState('');
    const [error, setError] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('selectedLanguage') || 'it'); // Initialize state
    const { dbType } = useContext(AppContext);
    const translations = getTranslation(currentLanguage); // Get translations for current language
    const navigate = useNavigate();

    // Listen for language changes
    useEffect(() => {
        const handleLanguageChange = () => {
            const newLanguage = localStorage.getItem('selectedLanguage') || 'it';
            if (newLanguage !== currentLanguage) {
                setCurrentLanguage(newLanguage);
                setError(''); // Clear error message on language change
            }
        };

        const interval = setInterval(handleLanguageChange, 500); // Check for language changes periodically
        return () => clearInterval(interval);
    }, [currentLanguage]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userId.trim()) {
            return setError(translations.loginError); // Use translated error message
        }

        try {
            const response = await fetch(`${API_BASE_URL}/user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-database-type': dbType
                },
                body: JSON.stringify({ id: userId })
            });

            const result = await response.json();

            if (response.ok) {
                localStorage.setItem('userId', userId);
                localStorage.removeItem('exerciseId'); // Set exercise to general
                navigate('/pages/general/intro'); // Navigate to Home page after successful login
            } else {
                const errorMessage = result.message ? `${result.error}: ${result.message}` : (result.error || translations.loginRequestError);
                setError(errorMessage); // Use translated error message or detailed error
            }
        } catch (err) {
            console.error(err);
            setError(translations.loginConnectionError); // Use translated error message
        }
    };

    return (
        <div className="login-wrapper">
            <Header />
            <div className="planet-background">
                <PlanetsBackground />
                <div className="login-form-container">
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder={translations.loginPlaceholder}
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                            className="login-input"
                        />
                        <button type="submit" className="login-button">{translations.loginButton}</button>
                        {error && <p className="login-error">{error}</p>}
                    </form>
                </div>

            </div>
            <Character name="Mars" position="left"/>
        </div>
    );
}
